import React, { Component } from "react";
import { TextField } from "material-ui";
import { CheckMarkIcon } from "../CheckMark";

const styles = {
  containerStyle: {
    position: "relative",
    width: "100%",
    display: "inline-block"
  },
  style: {
    width: "100%"
  },
  errorStyle: {},
  inputStyle: {
    color: "#555",
    paddingRight: "26px"
  },
  floatingLabelStyle: {
    color: "#ccc"
  },
  underlineStyle: {},
  underlineFocusStyle: {
    borderColor: "#ed135d"
  },
  errorIconStyle: {
    fontSize: "12px",
    verticalAlign: "bottom",
    fontWeight: "700"
  },
  validIconStyle: {
    fontSize: "24px",
    position: "absolute",
    right: "0",
    top: "50%",
    marginTop: "0",
    color: "#009600"
  }
};

class CustomTextField extends Component {
  renderTick = isValid => {
    if (isValid && this.props.errorText === "") {
      return (
        <i style={styles.validIconStyle}>
          <CheckMarkIcon />
        </i>
      );
    }
    return null;
  };

  render() {
    const errorText =
      this.props.errorText !== undefined && this.props.errorText !== "" ? (
        <span>
          <i className="material-icons" style={styles.errorIconStyle}>
            close
          </i>
          {" " + this.props.errorText}
        </span>
      ) : (
        this.props.errorText
      );
    const { isValid, ...restProps } = this.props;
    return (
      <span style={styles.containerStyle}>
        <TextField
          {...restProps}
          errorText={errorText}
          style={styles.style}
          floatingLabelStyle={styles.floatingLabelStyle}
          inputStyle={styles.inputStyle}
          errorStyle={styles.errorStyle}
          underlineStyle={styles.underlineStyle}
          underlineFocusStyle={styles.underlineFocusStyle}
        />
        {this.renderTick(isValid)}
      </span>
    );
  }
}

export { CustomTextField };



// WEBPACK FOOTER //
// ./src/modules/ContactForm/components/FormFields/TextField.js